import React, { useState, useEffect } from 'react';
import { 
  HiOutlineViewGrid, 
  HiOutlineDatabase,
  HiOutlineServer
} from 'react-icons/hi';
import { GiCog } from 'react-icons/gi';
import Card from '../../../../common/components/Card';
import { commonStyles } from '../../../../common/components/Layout/DashboardLayout';
import classNames from 'classnames';
import { useTheme } from '../../../../common/theme/themeContext';

const KskMainDashboard = () => {
  const { isDark } = useTheme();
  const [statsData, setStatsData] = useState({
    totalDevices: 0,
    activeDevices: 0,
    totalHours: 0,
    lastUpdate: null
  });

  useEffect(() => {
    // ここでksk用のAPIデータを取得
    // 現在はダミーデータを使用
    setStatsData({
      totalDevices: 12,
      activeDevices: 10,
      totalHours: 2847,
      lastUpdate: new Date()
    });
  }, []);

  const StatsCard = ({ title, value, unit, icon: Icon }) => (
    <Card className={commonStyles.card.padding.default}>
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <Icon className={classNames(
            "h-8 w-8",
            isDark ? "text-blue-400" : "text-blue-600"
          )} />
        </div>
        <div className="ml-5 w-0 flex-1">
          <dl>
            <dt className={classNames(
              commonStyles.text.subtitle,
              "truncate"
            )}>
              {title}
            </dt>
            <dd className="flex items-baseline">
              <div className={classNames(
                commonStyles.text.title,
                "text-2xl font-semibold"
              )}>
                {value}
              </div>
              {unit && (
                <div className={classNames(
                  commonStyles.text.caption,
                  "ml-2"
                )}>
                  {unit}
                </div>
              )}
            </dd>
          </dl>
        </div>
      </div>
    </Card>
  );

  return (
    <div className={commonStyles.layout.container}>
      <div className={commonStyles.layout.content}>
        <div className={commonStyles.layout.section}>
          <h1 className={classNames(
            commonStyles.text.title,
            "text-center text-3xl mb-8"
          )}>
            KSK Dashboard
          </h1>

          {/* Stats Cards */}
          <div className={classNames(
            commonStyles.grid.default,
            "grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
          )}>
            <StatsCard 
              title="総デバイス数"
              value={statsData.totalDevices}
              unit="台"
              icon={HiOutlineDatabase}
            />
            <StatsCard 
              title="稼働中デバイス"
              value={statsData.activeDevices}
              unit="台"
              icon={HiOutlineServer}
            />
            <StatsCard 
              title="総稼働時間"
              value={statsData.totalHours}
              unit="時間"
              icon={HiOutlineViewGrid}
            />
            <StatsCard 
              title="最終更新"
              value={statsData.lastUpdate ? new Date(statsData.lastUpdate).toLocaleDateString('ja-JP') : '-'}
              icon={GiCog}
            />
          </div>

          {/* 今後のチャートやその他のコンポーネントをここに追加 */}
          <Card className={classNames(
            commonStyles.card.padding.default,
            "text-center"
          )}>
            <h2 className={classNames(
              commonStyles.text.title,
              "text-xl mb-4"
            )}>
              KSK システム概要
            </h2>
            <p className={classNames(
              commonStyles.text.subtitle,
              "mb-4"
            )}>
              システムデータを表示するダッシュボードです。
            </p>
            <div className={classNames(
              "grid grid-cols-1 md:grid-cols-2 gap-6 mt-6"
            )}>
              <div className={classNames(
                commonStyles.card.padding.small,
                isDark ? "bg-gray-700" : "bg-gray-50",
                "rounded-lg"
              )}>
                <h3 className="font-semibold mb-2">システム状態</h3>
                <p className="text-green-600 dark:text-green-400">正常稼働中</p>
              </div>
              <div className={classNames(
                commonStyles.card.padding.small,
                isDark ? "bg-gray-700" : "bg-gray-50",
                "rounded-lg"
              )}>
                <h3 className="font-semibold mb-2">ネットワーク</h3>
                <p className="text-green-600 dark:text-green-400">接続良好</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default KskMainDashboard; 